import React from 'react';
import cn from 'classnames';

import styles from './PageHeading.module.css';

interface IProps {
    className?: string;
}

const PageHeading = (props: React.PropsWithChildren<IProps>) => {
    const className = cn(styles['page-heading'], props.className);

    return <h1 className={className}>{props.children}</h1>;
};

export default PageHeading;
